/** PRIVATE ENV */
export const EXPERIENCES_API_ENDPOINT = process.env.PRIVATE_EXPERIENCES_API_ENDPOINT as string;
export const TRANSPORTATION_API_ENDPOINT = process.env
  .PRIVATE_TRANSPORTATION_API_ENDPOINT as string;
export const AUTH_API_ENDPOINT = process.env.PRIVATE_AUTH_API_ENDPOINT as string;
export const CHANNEL_IO_SECRET_KEY = process.env.PRIVATE_CHANNEL_IO_SECRET_KEY as string;
export const MEMBER_API_ENDPOINT = process.env.PRIVATE_MEMBER_API_ENDPOINT as string;
export const DISCOVERY_API_ENDPOINT = process.env.PRIVATE_DISCOVERY_API_ENDPOINT as string;
